export default __webpack_public_path__ + "static/media/Karijera.7d1b4dba.jpg";